// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a0959432","421":"798a305c","631":"976551f9","711":"8b6a23bb","770":"21c34a31","950":"1afa3c74"}[chunkId] + ".chunk.js";
};